//#region Imports
import React from 'react';

import '../scss/Elements/_tables.scss';
import { Helmet } from 'react-helmet';
import { useTranslationHook } from '../hooks/UseTranslationHook';
import { MovementsTable } from '../components/Tables/MovementsTable';
//#endregion

function InventoryEntries() {
  const { titleInventoryString } = useTranslationHook();

  return (
    <div className='table-module-container'>
      <Helmet>
        <title>{titleInventoryString}</title>
      </Helmet>
      <div className='datatable'>
        <MovementsTable />
      </div>
    </div>
  );
}

export default InventoryEntries;
